import { render, staticRenderFns } from "./AyudaHistorico.vue?vue&type=template&id=5b63eaa0&scoped=true"
import script from "./AyudaHistorico.vue?vue&type=script&lang=js"
export * from "./AyudaHistorico.vue?vue&type=script&lang=js"
import style0 from "./AyudaHistorico.vue?vue&type=style&index=0&id=5b63eaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63eaa0",
  null
  
)

export default component.exports